import { __decorate } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Widget } from "@shop-builder/core/widget";
import { Configurator } from "@api/services/configurator";
import { formatEuro, formatPercent, getMonthlyPrice, isPercentage, hasMonthlyPrice, VluxMarkup, getPromoSubprices, } from "@api/utils";
import PropTypes from "@shop-builder/core/prop-types";
import { SERVICE_TYPE_DATA_VOLUME_BENEFIT, SERVICE_TYPE_DEVICE_INSURANCE, } from "@api/schema/offer";
import { BUNDLE_DESCRIPTION_ATTRIBUTE } from "@api/schema/product";
var CostOverviewWidget = /*@__PURE__*/ (function () {
    function CostOverviewWidget() {
        this.retries = 0;
    }
    CostOverviewWidget.prototype.didMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var $element;
            return __generator(this, function (_a) {
                $element = jQuery(this.getElement());
                if (!$element.hasClass("loaded")) {
                    $element.addClass("loaded");
                }
                Configurator.subscribe("offerChanged", this.render.bind(this));
                this.render();
                return [2 /*return*/];
            });
        });
    };
    CostOverviewWidget.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offer, tariff, product, amount, tariffName, deviceName, onetimeDeviceName, tariffBaseName, deviceBasePrice, monthly, onetime, additionalMonthlyCosts, additionalMonthlyCostsTpl, runtime, _i, _a, service, additionalOnetime, additionalMonthly, hasDeviceInsurance, _b, _c, option, insuranceValRow, benefits, benefitValues, tariffBasePrice, discountedTariffBasePrice, _d, _e, discount, highlightsHeight, _f, _g, highlightArea, height;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, Configurator.getOffer()];
                    case 1:
                        offer = _h.sent();
                        return [4 /*yield*/, Configurator.getTariff()];
                    case 2:
                        tariff = _h.sent();
                        if (!offer || !tariff) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Configurator.getAmount()];
                    case 3:
                        amount = _h.sent();
                        if (!Configurator.hasDeviceDetailModule())
                            return [3 /*break*/, 5];
                        return [4 /*yield*/, Configurator.getProduct()];
                    case 4:
                        product = _h.sent();
                        _h.label = 5;
                    case 5:
                        tariffName = amount + " x " + tariff.label;
                        deviceName = "";
                        onetimeDeviceName = "";
                        if (product) {
                            deviceName = amount + " x " + product.getLabel();
                            onetimeDeviceName = "Einmalzahlung " + deviceName;
                        }
                        this.getElement().querySelector("[data-tariff-name]").innerHTML =
                            tariffName;
                        this.getElement().querySelector("[data-device-name]").innerHTML =
                            deviceName;
                        tariffBaseName = "Tarif " + tariff.label;
                        this.getElement().querySelector("[data-tariff-base-name]").innerHTML =
                            tariffBaseName;
                        this.getElement().querySelector("[data-device-base-name]").innerHTML =
                            onetimeDeviceName;
                        if (product) {
                            deviceBasePrice = offer.getOnetimePrice() * amount;
                            this.getElement().querySelector("[data-device-base-price]").innerHTML = formatEuro(deviceBasePrice);
                        }
                        monthly = offer.getMonthlyPrice() * amount;
                        this.getElement().querySelector("[data-total-monthly]").innerHTML =
                            monthly > 0 ? formatEuro(monthly) : "0,00 &euro;";
                        if (product) {
                            onetime =
                                (offer.getOnetimePrice() + offer.getActivationFee()) * amount;
                        }
                        else {
                            onetime = offer.getActivationFee() * amount;
                        }
                        this.getElement().querySelector("[data-total-onetime]").innerHTML =
                            onetime > 0 ? formatEuro(onetime) : "0,00 &euro;";
                        additionalMonthlyCosts = offer.getMonthlyPriceAfterFirstYear() * amount;
                        additionalMonthlyCostsTpl = VluxMarkup(["Sie zahlen pro Monat"]);
                        if (!(monthly != additionalMonthlyCosts))
                            return [3 /*break*/, 7];
                        return [4 /*yield*/, getPromoSubprices(offer)[0].runtime];
                    case 6:
                        runtime = _h.sent();
                        if (runtime < 24 && runtime > 2) {
                            additionalMonthlyCostsTpl = VluxMarkup([
                                "\n                    Sie zahlen pro Monat<br>\n                    Ab dem " + getPromoSubprices(offer)[0].runtime + ". Monat <span data-sub-monthly>" + formatEuro(additionalMonthlyCosts) + "</span>\n                ",
                            ]);
                        }
                        _h.label = 7;
                    case 7:
                        this.getElement().querySelector("[data-sub-monthly]").innerHTML =
                            additionalMonthlyCostsTpl;
                        jQuery(".cost-overview-row.promo-row").addClass("displayNone");
                        this.getElement().querySelector(".promo-row .label").innerHTML = "";
                        for (_i = 0, _a = offer.getServicesByType(SERVICE_TYPE_DATA_VOLUME_BENEFIT); _i < _a.length; _i++) {
                            service = _a[_i];
                            this.getElement().querySelector(".promo-row .label").innerHTML +=
                                VluxMarkup([service.description.label]);
                            jQuery(".cost-overview-row.promo-row").removeClass("displayNone");
                        }
                        additionalOnetime = this.getElement().querySelector("[data-additional-onetime]");
                        additionalMonthly = this.getElement().querySelector("[data-additional-monthly]");
                        additionalOnetime.innerHTML = "";
                        additionalMonthly.innerHTML = "";
                        if (product) {
                            if (product.currentVersionContainsBundle()) {
                                additionalMonthly.innerHTML += this.createAdditionalItem("&nbsp;", "&nbsp;", true);
                                additionalOnetime.innerHTML += this.createAdditionalItem(product.getAttributeById(BUNDLE_DESCRIPTION_ATTRIBUTE)
                                    .value, "kostenlos");
                            }
                        }
                        hasDeviceInsurance = false;
                        /*
                        if (offer.getMonthlyServicesByType('visibleService').length > 0) {
                            for (const service of offer.getMonthlyServicesByType('visibleService')) {
                                console.log(service);
                                console.log(service.value);
                                additionalMonthly.innerHTML += this.createAdditionalItem(
                                    service.label,
                                    formatEuro(service.value * Configurator.getAmount())
                                );
                            }
                        }
                        */
                        if (offer.hasUsedOptions()) {
                            for (_b = 0, _c = offer.getUsedOptions(); _b < _c.length; _b++) {
                                option = _c[_b];
                                if (SERVICE_TYPE_DEVICE_INSURANCE ===
                                    option.description.additional.type) {
                                    hasDeviceInsurance = true;
                                    try {
                                        insuranceValRow = this.getElement().querySelector("[data-insurance-monthly]");
                                        insuranceValRow.innerHTML = formatEuro(getMonthlyPrice(option.prices) *
                                            Configurator.getAmount());
                                    }
                                    catch (e) {
                                        console.log("no insurance row found");
                                    }
                                }
                                else {
                                    additionalMonthly.innerHTML += this.createAdditionalItem(option.description.label, formatEuro(getMonthlyPrice(option.prices) *
                                        Configurator.getAmount()));
                                    additionalOnetime.innerHTML += this.createAdditionalItem("&nbsp;", "&nbsp;", true);
                                }
                            }
                        }
                        if (hasDeviceInsurance) {
                            jQuery(".insurance-row").removeClass("displayNone");
                        }
                        else {
                            jQuery(".insurance-row").addClass("displayNone");
                        }
                        this.getElement().querySelectorAll(".promo-row")[1].style.height = this.getElement().querySelectorAll(".promo-row")[0].offsetHeight + "px";
                        if (product) {
                            additionalMonthly.innerHTML += this.createAdditionalItem("Gerätezuzahlung", formatEuro(offer.getDeviceMonthlyPrice() * amount));
                            /*
                            additionalOnetime.innerHTML += this.createAdditionalItem(
                                '&nbsp;',
                                '&nbsp;',
                                true
                            );
                            */
                            this.getElement()
                                .querySelector(".cost-overview-row.device")
                                .classList.remove("displayNone");
                        }
                        else {
                            // this.getElement().querySelector('.total-costs-onetime').style.display= `none`;
                            this.getElement()
                                .querySelector(".cost-overview-row.device")
                                .classList.add("displayNone");
                        }
                        benefits = this.getElement().querySelector("[data-benefits]");
                        benefitValues = this.getElement().querySelector(".highlight .value");
                        benefits.innerHTML = "";
                        benefitValues.innerHTML = '<div style="margin-top:25px"></div>';
                        tariffBasePrice = offer.getTariffBasePrice() * amount;
                        this.getElement().querySelector("[data-tariff-base-price]").innerHTML =
                            formatEuro(tariffBasePrice);
                        discountedTariffBasePrice = tariffBasePrice;
                        this.getElement()
                            .querySelector("[data-tariff-base-price]")
                            .classList.remove("discounted");
                        this.getElement()
                            .querySelector("[data-activation-fee]")
                            .classList.remove("discounted");
                        this.getElement().querySelector("[data-activation-fee]").innerHTML =
                            formatEuro(offer.getActivationFee() * amount);
                        if (offer.isDiscounted()) {
                            for (_d = 0, _e = offer.getDiscounts(); _d < _e.length; _d++) {
                                discount = _e[_d];
                                benefits.innerHTML += "<li>" + discount.description.label + "</li>";
                                if (hasMonthlyPrice(discount.prices) &&
                                    !isPercentage(discount.prices)) {
                                    benefitValues.innerHTML += "<div>" + formatEuro(getMonthlyPrice(discount.prices) * amount) + "</div>";
                                    discountedTariffBasePrice +=
                                        getMonthlyPrice(discount.prices) * amount;
                                }
                                else if (hasMonthlyPrice(discount.prices) &&
                                    isPercentage(discount.prices)) {
                                    benefitValues.innerHTML += "<div>" + formatPercent(getMonthlyPrice(discount.prices)) + "</div>";
                                    discountedTariffBasePrice -=
                                        tariffBasePrice *
                                            (getMonthlyPrice(discount.prices) / 100);
                                }
                                else {
                                    benefitValues.innerHTML += "<div>&nbsp;</div>";
                                }
                            }
                            jQuery(".cost-overview-row.description").removeClass("displayNone");
                        }
                        else {
                            jQuery(".cost-overview-row.description").addClass("displayNone");
                        }
                        highlightsHeight = 0;
                        for (_f = 0, _g = this.getElement().querySelectorAll(".cost-overview-row.description"); _f < _g.length; _f++) {
                            highlightArea = _g[_f];
                            height = jQuery(highlightArea).height();
                            if (height > highlightsHeight) {
                                highlightsHeight = height;
                            }
                        }
                        jQuery(".cost-overview-row.description.onetime").height(highlightsHeight);
                        this.retries = 0;
                        return [2 /*return*/];
                }
            });
        });
    };
    CostOverviewWidget.prototype.registerScrollEvent = function () {
        var $element = jQuery(this.getElement());
        var handleAnimationEnter = function () {
            var top_of_element = $element.offset().top + 250;
            var bottom_of_element = $element.offset().top + $element.outerHeight() - 450;
            var bottom_of_screen = jQuery(window).scrollTop() + window.innerHeight;
            var top_of_screen = jQuery(window).scrollTop();
            if (bottom_of_screen > top_of_element &&
                top_of_screen < bottom_of_element) {
                if (!$element.hasClass("loaded")) {
                    $element.addClass("loaded");
                }
            }
        };
        jQuery(window).scroll(handleAnimationEnter);
        handleAnimationEnter();
    };
    CostOverviewWidget.prototype.createAdditionalItem = function (label, value, emptyLine) {
        var template = "\n            <div class=\"cost-overview-row " + (emptyLine ? "empty-line" : "") + "\">\n                <div class=\"label\">\n                    " + label + "\n                </div>\n                <div class=\"value\">\n                    " + value + "\n                </div>\n            </div>\n        ";
        return template;
    };
    CostOverviewWidget.prototype.resetAmount = function () {
        setTimeout(function () {
            Configurator.setAmount(1);
        }, 500);
    };
    CostOverviewWidget.propTypes = {
        devicelisting: PropTypes.String,
        hubpage: PropTypes.String,
    };
    CostOverviewWidget = __decorate([
        Widget({
            name: "cost-overview",
        })
    ], CostOverviewWidget);
    return CostOverviewWidget;
}());
export { CostOverviewWidget };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/cost-overview/cost-overview.ts
// module id = null
// module chunks = 